import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "@irati/ui/src/Layout"
import {FormattedMessage} from "@irati/utils/lang"
import StyledButton from "./styled/ShowMoreButton"

const ShowMoreButton = (props) => {
  return (
    <Row>
      <Col xs={12}>
        <StyledButton large onClick={props.onClick}>
          <FormattedMessage id="perks.components.dealList.showMoreButton" />
        </StyledButton>
      </Col>
    </Row>
  )
}

ShowMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default ShowMoreButton
